export default {
  // language=HTML (for PhpStorm)
  template: `
    <ui-form-partial label="Terms" class="is-terms-partial">
      <p>
        <b>Fees & Deposit Information:</b> A $30 connection/transfer fee and $10 membership fee
        is required of all members. <b>To determine if a security deposit is required, we will
        run a credit check using your social security number or federal tax ID number.</b> If
        you do not wish to have your credit checked, a maximum deposit will be required.
        If a deposit is required, it will need to be paid before service is established.
      </p>

      <ui-form-item prop="termsAndConditions.accepts">
        <ui-form-checkbox
          name="service_accepts_terms"
          v-model="model.termsAndConditions.accepts"
          label="I accept and agree to the terms and conditions of the below disclaimer."
        />
      </ui-form-item>

      <p>
        DISCLAIMER: RUTHERFORD ELECTRIC MEMBERSHIP CORPORATION AGREES TO PROVIDE ELECTRIC
        UTILITY SERVICE TO THE SIGNED CUSTOMER. UPON SIGNING, APPLICANT AND CO-APPLICANT
        CONFIRM ALL INFORMATION PROVIDED HEREIN IS TRUTHFUL AND ACCURATE, AND ALSO AGREE
        TO COMPLY WITH REMC’S SERVICE RULES AND REGULATIONS, AND TO PROMPTLY PAY FOR
        SERVICES RECEIVED. UPON ACCEPTANCE BY CHECKING THE BOX BELOW, THIS FORM WILL SERVE
        AS A CERTIFICATE OF MEMBERSHIP AND WILL BE FILED ELECTRONICALLY AT REMC.
      </p>

      <ui-form-item prop="termsAndConditions.understandsElectronicSignature">
        <ui-form-checkbox
          name="understands_esignature"
          v-model="model.termsAndConditions.understandsElectronicSignature"
          :value="true"
          label="I understand that checking this box and typing my name in the field 
            provided below is my electronic signature."
        />
      </ui-form-item>

      <ui-form-item
        label="Applicant Signature"
        prop="termsAndConditions.signature"
      >
        <ui-form-input
          name="service_agreement_signature"
          v-model="model.termsAndConditions.signature"
        />
      </ui-form-item>
    </ui-form-partial>
  `,

  props: {
    model: Object,
  },
}
